module.exports = __webpack_public_path__ + "img/022-chat.2d8d9fa0.svg";